(() => {
  const navigators = document.querySelectorAll('.sp-catalog-nav__picker');

  navigators.forEach((picker) => {
    picker.addEventListener('toggle', () => {
      if (!picker.open) return;
      navigators.forEach((otherPicker) => {
        if (otherPicker !== picker) otherPicker.removeAttribute('open');
      });
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    navigators.forEach((picker) => picker.removeAttribute('open'));
  });

  document.addEventListener('click', (event) => {
    navigators.forEach((picker) => {
      if (!picker.contains(event.target)) picker.removeAttribute('open');
    });
  });
})();
